export enum SeanceStatuses {
  SENT = 'ENVOYEE',
  MASTERING = 'MASTERING',
  AWAITING_CUTOUT = 'A DECOUPER',
  ONGOING_CUTOUT = 'EN COURS DE DECOUPE',
  CANCELED = 'ANNULEE',
  DONE = 'INTEGREE'
}
